/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.5.0.0 (NJsonSchema v10.1.15.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { AuthWithCookies } from './AuthWithCookies';

export class UsersClient extends AuthWithCookies {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "localhost:3001/api";
    }

    /**
     * @param id ID of user
     * @return Ok
     */
    getUserPrivileges(id: string): Promise<Privilege[]> {
        let url_ = this.baseUrl + "/users/{id}/privileges";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserPrivileges(_response);
        });
    }

    protected processGetUserPrivileges(response: Response): Promise<Privilege[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Privilege.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Privilege[]>(<any>null);
    }

    /**
     * @param id ID of user
     * @return Ok
     */
    getUser(id: string): Promise<User> {
        let url_ = this.baseUrl + "/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(<any>null);
    }

    /**
     * @param id ID of the user to update
     * @param body Updated properties
     * @return Ok
     */
    updateUser(id: string, body: UserUpdateRequest): Promise<User> {
        let url_ = this.baseUrl + "/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(<any>null);
    }

    /**
     * @param id ID of the user to delete
     * @return No content
     */
    deleteUser(id: string): Promise<void> {
        let url_ = this.baseUrl + "/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param namesOnly (optional) Flag: if true, request a flat array of all visible users withminimal information (so without assignments)
     * @param count (optional) Flag: if true, add field with count of all users. Meant for paging
     * @param limit (optional) Limit the amount of users returned to specified number. Meant for paging
     * @param start (optional) Starting index of limited request. Meant for paging
     * @param ordering (optional) List of properties with 'asc'/'desc' to order users on
     * @param ws (optional) 
     * @param as (optional) 
     * @param gs (optional) 
     * @param search (optional) Search string
     * @return Ok
     */
    getUsers(namesOnly: boolean | null | undefined, count: boolean | null | undefined, limit: number | null | undefined, start: number | null | undefined, ordering: string | null | undefined, ws: string | null | undefined, as: string | null | undefined, gs: string | null | undefined, search: string | null | undefined): Promise<UserCollection> {
        let url_ = this.baseUrl + "/users?";
        if (namesOnly !== undefined && namesOnly !== null)
            url_ += "namesOnly=" + encodeURIComponent("" + namesOnly) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (ordering !== undefined && ordering !== null)
            url_ += "ordering=" + encodeURIComponent("" + ordering) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "ws": ws !== undefined && ws !== null ? "" + ws : "",
                "as": as !== undefined && as !== null ? "" + as : "",
                "gs": gs !== undefined && gs !== null ? "" + gs : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }


    /**
     * @param namesOnly (optional) Flag: if true, request a flat array of all visible users withminimal information (so without assignments)
     * @param count (optional) Flag: if true, add field with count of all users. Meant for paging
     * @param limit (optional) Limit the amount of users returned to specified number. Meant for paging
     * @param start (optional) Starting index of limited request. Meant for paging
     * @param ordering (optional) List of properties with 'asc'/'desc' to order users on
     * @param ws (optional) 
     * @param as (optional) 
     * @param gs (optional) 
     * @param search (optional) Search string
     * @return Ok
     */
    getUsersIds(namesOnly: boolean | null | undefined, count: boolean | null | undefined, limit: number | null | undefined, start: number | null | undefined, ordering: string | null | undefined, ws: string | null | undefined, as: string | null | undefined, gs: string | null | undefined, search: string | null | undefined): Promise<UserCollection> {
        let url_ = this.baseUrl + "/users/uids?";
        if (namesOnly !== undefined && namesOnly !== null)
            url_ += "namesOnly=" + encodeURIComponent("" + namesOnly) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (ordering !== undefined && ordering !== null)
            url_ += "ordering=" + encodeURIComponent("" + ordering) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "ws": ws !== undefined && ws !== null ? "" + ws : "",
                "as": as !== undefined && as !== null ? "" + as : "",
                "gs": gs !== undefined && gs !== null ? "" + gs : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }


    protected processGetUsers(response: Response): Promise<UserCollection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCollection.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = WrappedErrorForbiddenError.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserCollection>(<any>null);
    }

    /**
     * @param body User properties
     * @return Ok
     */
    createUser(body: UserCreationRequest): Promise<User> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(<any>null);
    }

    /**
     * @param body Has list of user IDs to delete
     * @return No content
     */
    bulkDeleteUsers(body: UserBulkDeleteRequest): Promise<void> {
        let url_ = this.baseUrl + "/users/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeleteUsers(_response);
        });
    }

    protected processBulkDeleteUsers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body Has list of user IDs and group IDs
     * @return Ok
     */
    bulkAssignGroupsAll(body: UserBulkAssignGroupRequest): Promise<User[]> {
        let url_ = this.baseUrl + "/users/groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAssignGroupsAll(_response);
        });
    }

    protected processBulkAssignGroupsAll(response: Response): Promise<User[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(<any>null);
    }

    /**
     * @param body Has list of user IDs and application IDs
     * @return Ok
     */
    bulkAssignApplicationsAll(body: UserBulkAssignApplicationRequest): Promise<User[]> {
        let url_ = this.baseUrl + "/users/applications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAssignApplicationsAll(_response);
        });
    }

    protected processBulkAssignApplicationsAll(response: Response): Promise<User[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(<any>null);
    }

    /**
     * @return Ok
     */
    createApplicationKey(body: UserCreateApplicationKeyRequest): Promise<string> {
        let url_ = this.baseUrl + "/users/applicationKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateApplicationKey(_response);
        });
    }

    protected processCreateApplicationKey(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return Ok
     */
    getApplicationKeys(id: string): Promise<Anonymous[]> {
        let url_ = this.baseUrl + "/users/{id}/applicationKeys";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetApplicationKeys(_response);
        });
    }

    protected processGetApplicationKeys(response: Response): Promise<Anonymous[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Anonymous.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Anonymous[]>(<any>null);
    }

    /**
     * @return No content
     */
    deleteApplicationKey(id: string, body: any): Promise<void> {
        let url_ = this.baseUrl + "/users/{id}/applicationKey";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteApplicationKey(_response);
        });
    }

    protected processDeleteApplicationKey(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body Has list of user IDs and the workspace ID
     * @return Ok
     */
    bulkAssignWorkspaceAll(body: UserBulkAssignWorkspaceRequest): Promise<User[]> {
        let url_ = this.baseUrl + "/users/workspace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAssignWorkspaceAll(_response);
        });
    }

    protected processBulkAssignWorkspaceAll(response: Response): Promise<User[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(<any>null);
    }

    /**
     * @param body Has list of user IDs to synchronize
     * @return No content
     */
    bulkSynchronize(body: UserSynchronizeRequest): Promise<void> {
        let url_ = this.baseUrl + "/users/synchronize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkSynchronize(_response);
        });
    }

    protected processBulkSynchronize(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body Has list of user IDs to activate
     * @return No content
     */
    bulkActivateUsers(body: UserBulkActivateRequest): Promise<void> {
        let url_ = this.baseUrl + "/users/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkActivateUsers(_response);
        });
    }

    protected processBulkActivateUsers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body Has list of user IDs to update
     * @return No content
     */
    bulkUpdateADUsers(body: UserBulkUpdateAD): Promise<void> {
        let url_ = this.baseUrl + "/users/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateADUsers(_response);
        });
    }

    protected processBulkUpdateADUsers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body Has list of user IDs to deactivate
     * @return No content
     */
    bulkDeactivateUsers(body: UserBulkDeactivateRequest): Promise<void> {
        let url_ = this.baseUrl + "/users/deactivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeactivateUsers(_response);
        });
    }

    protected processBulkDeactivateUsers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body Has list of users to mail and contains mail type
     * @return No content
     */
    bulkMailUsers(body: UserBulkMailRequest): Promise<void> {
        let url_ = this.baseUrl + "/users/mail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMailUsers(_response);
        });
    }

    protected processBulkMailUsers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body Contains CSV and request
     * @return No content
     */
    importCSV(body: ImportCSVRequest): Promise<void> {
        let url_ = this.baseUrl + "/users/csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportCSV(_response);
        });
    }

    protected processImportCSV(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ApplicationsClient extends AuthWithCookies {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "localhost:3001/api";
    }

    /**
     * @param id ID of application
     * @return Ok
     */
    getApplication(id: string): Promise<Application> {
        let url_ = this.baseUrl + "/applications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetApplication(_response);
        });
    }

    protected processGetApplication(response: Response): Promise<Application> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Application.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Application>(<any>null);
    }

    /**
     * @param id ID of the application to update
     * @param body Updated properties
     * @return Ok
     */
    updateApplication(id: string, body: ApplicationUpdateRequest): Promise<Application> {
        let url_ = this.baseUrl + "/applications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateApplication(_response);
        });
    }

    protected processUpdateApplication(response: Response): Promise<Application> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Application.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Application>(<any>null);
    }

    /**
     * @param id ID of the application to delete
     * @return No content
     */
    deleteApplication(id: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteApplication(_response);
        });
    }

    protected processDeleteApplication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param namesOnly (optional) Flag: if true, request a flat array of all visible applications withminimal information (so without assignments)
     * @param count (optional) Flag: if true, add field with count of all applications. Meant for paging
     * @param limit (optional) Limit the amount of applications returned to specified number. Meant for paging
     * @param start (optional) Starting index of limited request. Meant for paging
     * @param ordering (optional) List of properties with 'asc'/'desc' to order applications on
     * @param u (optional) List of user IDs to filter on
     * @param w (optional) List of workspace IDs to filter on
     * @param s (optional) List of server IDs to filter on
     * @param t (optional) taskprocessor status
     * @param search (optional) Search string
     * @return Ok
     */
    getApplications(namesOnly: boolean | null | undefined, count: boolean | null | undefined, limit: number | null | undefined, start: number | null | undefined, ordering: string | null | undefined, u: string[] | null | undefined, w: string[] | null | undefined, s: string[] | null | undefined, t: string[] | null | undefined, search: string | null | undefined): Promise<ApplicationCollection> {
        let url_ = this.baseUrl + "/applications?";
        if (namesOnly !== undefined && namesOnly !== null)
            url_ += "namesOnly=" + encodeURIComponent("" + namesOnly) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (ordering !== undefined && ordering !== null)
            url_ += "ordering=" + encodeURIComponent("" + ordering) + "&";
        if (u !== undefined && u !== null)
            u && u.forEach(item => { url_ += "u=" + encodeURIComponent("" + item) + "&"; });
        if (w !== undefined && w !== null)
            w && w.forEach(item => { url_ += "w=" + encodeURIComponent("" + item) + "&"; });
        if (s !== undefined && s !== null)
            s && s.forEach(item => { url_ += "s=" + encodeURIComponent("" + item) + "&"; });
        if (t !== undefined && t !== null)
            t && t.forEach(item => { url_ += "t=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetApplications(_response);
        });
    }

    protected processGetApplications(response: Response): Promise<ApplicationCollection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationCollection.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationCollection>(<any>null);
    }

    /**
     * @param body Application properties
     * @return Ok
     */
    createApplication(body: ApplicationCreationRequest): Promise<Application> {
        let url_ = this.baseUrl + "/applications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateApplication(_response);
        });
    }

    protected processCreateApplication(response: Response): Promise<Application> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Application.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Application>(<any>null);
    }

    /**
     * @param body Has list of application IDs to delete
     * @return No content
     */
    bulkDeleteApplications(body: ApplicationBulkDeleteRequest): Promise<void> {
        let url_ = this.baseUrl + "/applications/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeleteApplications(_response);
        });
    }

    protected processBulkDeleteApplications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body Has list of application IDs and the workspace ID
     * @return No content
     */
    bulkAssignWorkspace(body: ApplicationBulkAssignWorkspaceRequest): Promise<void> {
        let url_ = this.baseUrl + "/applications/workspace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAssignWorkspace(_response);
        });
    }

    protected processBulkAssignWorkspace(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body Has list of applications to synchronize
     * @return No content
     */
    bulkSynchronize2(body: ApplicationSynchronizeRequest): Promise<void> {
        let url_ = this.baseUrl + "/applications/synchronize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkSynchronize2(_response);
        });
    }

    protected processBulkSynchronize2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Ok
     */
    getMaintenanceMode(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/applications/maintenanceMode/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMaintenanceMode(_response);
        });
    }

    protected processGetMaintenanceMode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @return Ok
     */
    setMaintenanceMode(id: string, body: ApplicationMaintenanceModeRequest): Promise<boolean> {
        let url_ = this.baseUrl + "/applications/maintenanceMode/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetMaintenanceMode(_response);
        });
    }

    protected processSetMaintenanceMode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

     /**

     * @return Ok

     */

    getServerAliases(): Promise<string[]> {
        let url_ = this.baseUrl + "/applications/meta/serverAliases";
        url_ = url_.replace(/[?&]$/, "");
        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }

        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServerAliases(_response);
        });
    }

    protected processGetServerAliases(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class GroupsClient extends AuthWithCookies {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "localhost:3001/api";
    }

    /**
     * @param id ID of group
     * @return Ok
     */
    getGroup(id: string): Promise<Group> {
        let url_ = this.baseUrl + "/groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroup(_response);
        });
    }

    protected processGetGroup(response: Response): Promise<Group> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Group.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group>(<any>null);
    }

    /**
     * @param id ID of the group to update
     * @param body Updated properties
     * @return Ok
     */
    updateGroup(id: string, body: GroupUpdateRequest): Promise<Group> {
        let url_ = this.baseUrl + "/groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGroup(_response);
        });
    }

    protected processUpdateGroup(response: Response): Promise<Group> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Group.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group>(<any>null);
    }

    /**
     * @param id ID of the group to delete
     * @return No content
     */
    deleteGroup(id: string): Promise<void> {
        let url_ = this.baseUrl + "/groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGroup(_response);
        });
    }

    protected processDeleteGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }


    /**
     * @param namesOnly (optional) Flag: if true, request a flat array of all visible groups withminimal information (so without assignments)
     * @param count (optional) Flag: if true, add field with count of all groups. Meant for paging
     * @param limit (optional) Limit the amount of groups returned to specified number. Meant for paging
     * @param start (optional) Starting index of limited request. Meant for paging
     * @param ordering (optional) List of properties with 'asc'/'desc' to order groups on
     * @param u (optional) List of user IDs to filter on
     * @param w (optional) List of workspace IDs to filter on
     * @param search (optional) Search string
     * @return Ok
     */
    getGroupsByWorkspace( w: string[] | null | undefined): Promise<GroupCollection> {
        let url_ = this.baseUrl + "/workspace?";
        
        if (w !== undefined && w !== null)
            w && w.forEach(item => { url_ += "w=" + encodeURIComponent("" + item) + "&"; });
       
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroups(_response);
        });
    }


    /**
     * @param namesOnly (optional) Flag: if true, request a flat array of all visible groups withminimal information (so without assignments)
     * @param count (optional) Flag: if true, add field with count of all groups. Meant for paging
     * @param limit (optional) Limit the amount of groups returned to specified number. Meant for paging
     * @param start (optional) Starting index of limited request. Meant for paging
     * @param ordering (optional) List of properties with 'asc'/'desc' to order groups on
     * @param u (optional) List of user IDs to filter on
     * @param w (optional) List of workspace IDs to filter on
     * @param search (optional) Search string
     * @return Ok
     */
    getGroups(namesOnly: boolean | null | undefined, count: boolean | null | undefined, limit: number | null | undefined, start: number | null | undefined, ordering: string | null | undefined, u: string[] | null | undefined, w: string[] | null | undefined, search: string | null | undefined): Promise<GroupCollection> {
        let url_ = this.baseUrl + "/groups?";
        if (namesOnly !== undefined && namesOnly !== null)
            url_ += "namesOnly=" + encodeURIComponent("" + namesOnly) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (ordering !== undefined && ordering !== null)
            url_ += "ordering=" + encodeURIComponent("" + ordering) + "&";
        if (u !== undefined && u !== null)
            u && u.forEach(item => { url_ += "u=" + encodeURIComponent("" + item) + "&"; });
        if (w !== undefined && w !== null)
            w && w.forEach(item => { url_ += "w=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroups(_response);
        });
    }

    protected processGetGroups(response: Response): Promise<GroupCollection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupCollection.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupCollection>(<any>null);
    }

    /**
     * @param body Group properties
     * @return Ok
     */
    createGroup(body: GroupCreationRequest): Promise<Group> {
        let url_ = this.baseUrl + "/groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGroup(_response);
        });
    }

    protected processCreateGroup(response: Response): Promise<Group> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Group.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group>(<any>null);
    }

    /**
     * @param body Has list of group IDs to delete
     * @return No content
     */
    bulkDeleteGroups(body: GroupBulkDeleteRequest): Promise<void> {
        let url_ = this.baseUrl + "/groups/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeleteGroups(_response);
        });
    }

    protected processBulkDeleteGroups(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body Has list of group IDs and the workspace IDs
     * @return No content
     */
    bulkAssignWorkspace2(body: GroupBulkAssignWorkspacesRequest): Promise<void> {
        let url_ = this.baseUrl + "/groups/workspace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAssignWorkspace2(_response);
        });
    }

    protected processBulkAssignWorkspace2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class WorkspacesClient extends AuthWithCookies {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "localhost:3001/api";
    }

    /**
     * @param id ID of workspace
     * @return Ok
     */
    getWorkspace(id: string): Promise<Workspace> {
        let url_ = this.baseUrl + "/workspaces/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWorkspace(_response);
        });
    }

    protected processGetWorkspace(response: Response): Promise<Workspace> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Workspace.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Workspace>(<any>null);
    }

    /**
     * @param id ID of the workspace to update
     * @param body Updated properties
     * @return Ok
     */
    updateWorkspace(id: string, body: WorkspaceUpdateRequest): Promise<Workspace> {
        let url_ = this.baseUrl + "/workspaces/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateWorkspace(_response);
        });
    }

    protected processUpdateWorkspace(response: Response): Promise<Workspace> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Workspace.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Workspace>(<any>null);
    }

    /**
     * @param id ID of the workspace to delete
     * @return No content
     */
    deleteWorkspace(id: string): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteWorkspace(_response);
        });
    }

    protected processDeleteWorkspace(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param namesOnly (optional) Flag: if true, request a flat array of all visible workspaces withminimal information (so without assignments)
     * @param count (optional) Flag: if true, add field with count of all workspaces. Meant for paging
     * @param limit (optional) Limit the amount of workspaces returned to specified number. Meant for paging
     * @param start (optional) Starting index of limited request. Meant for paging
     * @param ordering (optional) List of properties with 'asc'/'desc' to order workspaces on
     * @param u (optional) List of user IDs to filter on
     * @param a (optional) List of application IDs to filter on
     * @param g (optional) List of group IDs to filter on
     * @param search (optional) Search string
     * @return Ok
     */
    getWorkspaces(namesOnly: boolean | null | undefined, count: boolean | null | undefined, limit: number | null | undefined, start: number | null | undefined, ordering: string | null | undefined, u: string[] | null | undefined, a: string[] | null | undefined, g: string[] | null | undefined, search: string | null | undefined): Promise<WorkspaceCollection> {
        let url_ = this.baseUrl + "/workspaces?";
        if (namesOnly !== undefined && namesOnly !== null)
            url_ += "namesOnly=" + encodeURIComponent("" + namesOnly) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (ordering !== undefined && ordering !== null)
            url_ += "ordering=" + encodeURIComponent("" + ordering) + "&";
        if (u !== undefined && u !== null)
            u && u.forEach(item => { url_ += "u=" + encodeURIComponent("" + item) + "&"; });
        if (a !== undefined && a !== null)
            a && a.forEach(item => { url_ += "a=" + encodeURIComponent("" + item) + "&"; });
        if (g !== undefined && g !== null)
            g && g.forEach(item => { url_ += "g=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWorkspaces(_response);
        });
    }

    protected processGetWorkspaces(response: Response): Promise<WorkspaceCollection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceCollection.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceCollection>(<any>null);
    }

    /**
     * @param body Workspace properties
     * @return Ok
     */
    createWorkspace(body: WorkspaceCreationRequest): Promise<Workspace> {
        let url_ = this.baseUrl + "/workspaces";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateWorkspace(_response);
        });
    }

    protected processCreateWorkspace(response: Response): Promise<Workspace> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Workspace.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Workspace>(<any>null);
    }

    /**
     * @param body Has list of workspace IDs to delete
     * @return No content
     */
    bulkDeleteWorkspaces(body: WorkspaceBulkDeleteRequest): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeleteWorkspaces(_response);
        });
    }

    protected processBulkDeleteWorkspaces(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body Has list of application IDs and the workspace ID. This single workspace IDhas to be wrapped in an array, this should be refactored
     * @return No content
     */
    bulkAssignApplications(body: WorkspaceBulkAssignApplicationsRequest): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/applications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAssignApplications(_response);
        });
    }

    protected processBulkAssignApplications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body Has list of application IDs and the workspace ID
     * @return No content
     */
    bulkAssignGroups(body: WorkspaceBulkAssignGroupsRequest): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAssignGroups(_response);
        });
    }

    protected processBulkAssignGroups(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class Client extends AuthWithCookies {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "localhost:3001/api";
    }

    /**
     * @return Ok
     */
    getProfile(): Promise<UserProfile> {
        let url_ = this.baseUrl + "/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProfile(_response);
        });
    }

    protected processGetProfile(response: Response): Promise<UserProfile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfile.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfile>(<any>null);
    }

    /**
     * @return No content
     */
    logout(): Promise<void> {
        let url_ = this.baseUrl + "/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param hostname hostname of the server to which the request is made.Useful for determining auth strategy
     * @param task (optional) 
     * @param url (optional) 
     * @param email (optional) 
     * @param userName (optional) 
     * @return Ok
     */
    loggedIn(hostname: string, task: string | null | undefined, url: string | null | undefined, email: string | null | undefined, userName: string | null | undefined): Promise<LoggedInResponse> {
        let url_ = this.baseUrl + "/loggedIn?";
        if (hostname === undefined || hostname === null)
            throw new Error("The parameter 'hostname' must be defined and cannot be null.");
        else
            url_ += "hostname=" + encodeURIComponent("" + hostname) + "&";
        if (task !== undefined && task !== null)
            url_ += "task=" + encodeURIComponent("" + task) + "&";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoggedIn(_response);
        });
    }

    protected processLoggedIn(response: Response): Promise<LoggedInResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoggedInResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoggedInResponse>(<any>null);
    }

    /**
     * @return Ok
     */
    checkSelf(): Promise<CheckSelfInfo> {
        let url_ = this.baseUrl + "/checkSelf";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckSelf(_response);
        });
    }

    protected processCheckSelf(response: Response): Promise<CheckSelfInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckSelfInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckSelfInfo>(<any>null);
    }

    /**
     * @return Ok
     */
    getAbout(): Promise<About> {
        let url_ = this.baseUrl + "/about";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAbout(_response);
        });
    }

    protected processGetAbout(response: Response): Promise<About> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = About.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<About>(<any>null);
    }

    /**
     * @return Ok
     */
    getSessions(): Promise<User[]> {
        let url_ = this.baseUrl + "/sessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSessions(_response);
        });
    }

    protected processGetSessions(response: Response): Promise<User[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(<any>null);
    }

    /**
     * @param token Token to check
     * @return Ok
     */
    checkAnonymousLoginToken(token: string): Promise<ApplicationTokenResponse> {
        let url_ = this.baseUrl + "/anonymousLogin?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckAnonymousLoginToken(_response);
        });
    }

    protected processCheckAnonymousLoginToken(response: Response): Promise<ApplicationTokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationTokenResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationTokenResponse>(<any>null);
    }

    /**
     * @param application Properties of the application to create
     * @return No content
     */
    postImportApplication(application: ApplicationCreationRequest): Promise<void> {
        let url_ = this.baseUrl + "/importApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(application);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostImportApplication(_response);
        });
    }

    protected processPostImportApplication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return No content
     */
    syncAllUsers(): Promise<void> {
        let url_ = this.baseUrl + "/synchAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSyncAllUsers(_response);
        });
    }    

    protected processSyncAllUsers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param application Properties of the application to create
     * @return No content
     */
    postMigrateApplication(application: ApplicationMigrationRequest): Promise<void> {
        let url_ = this.baseUrl + "/migrateApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(application);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostMigrateApplication(_response);
        });
    }

    protected processPostMigrateApplication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param applicationId Application ID to get a token for
     * @return Ok
     */
    getApplicationToken(applicationId: string): Promise<ApplicationTokenResponse> {
        let url_ = this.baseUrl + "/appToken?";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined and cannot be null.");
        else
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetApplicationToken(_response);
        });
    }

    protected processGetApplicationToken(response: Response): Promise<ApplicationTokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationTokenResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationTokenResponse>(<any>null);
    }

    /**
     * @return Ok
     */
    getZendeskToken(): Promise<ZendeskTokenResponse> {
        let url_ = this.baseUrl + "/zendeskToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetZendeskToken(_response);
        });
    }

    protected processGetZendeskToken(response: Response): Promise<ZendeskTokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZendeskTokenResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ZendeskTokenResponse>(<any>null);
    }

    /**
     * @param hostname Hostname of server
     * @return Ok
     */
    getServerKey(hostname: string): Promise<Anonymous2> {
        let url_ = this.baseUrl + "/serverKey?";
        if (hostname === undefined || hostname === null)
            throw new Error("The parameter 'hostname' must be defined and cannot be null.");
        else
            url_ += "hostname=" + encodeURIComponent("" + hostname) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServerKey(_response);
        });
    }

    protected processGetServerKey(response: Response): Promise<Anonymous2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Anonymous2>(<any>null);
    }

    /**
     * @return Ok
     */
    getAssignPrivileges(): Promise<Privilege[]> {
        let url_ = this.baseUrl + "/privileges";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignPrivileges(_response);
        });
    }

    protected processGetAssignPrivileges(response: Response): Promise<Privilege[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Privilege.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Privilege[]>(<any>null);
    }

    /**
     * @return No content
     */
    removeAlias(): Promise<void> {
        let url_ = this.baseUrl + "/login-as";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveAlias(_response);
        });
    }

    protected processRemoveAlias(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id ID of user to log in as
     * @return No content
     */
    postAlias(id: string): Promise<void> {
        let url_ = this.baseUrl + "/login-as/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostAlias(_response);
        });
    }

    protected processPostAlias(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = WrappedErrorInputError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body Contains email address to send link to
     * @return No content
     */
    forgotPassword(body: ForgotPasswordRequest): Promise<void> {
        let url_ = this.baseUrl + "/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = WrappedErrorInputError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id ID of user resetting password
     * @param token Token in emailed link
     * @return No content
     */
    checkPasswordResetToken(id: string, token: string): Promise<void> {
        let url_ = this.baseUrl + "/reset-password?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckPasswordResetToken(_response);
        });
    }

    protected processCheckPasswordResetToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = WrappedErrorInputError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id ID of user resetting password
     * @param token Token in emailed link
     * @param body Contains new password
     * @return No content
     */
    postPasswordReset(id: string, token: string, body: PasswordResetRequest): Promise<void> {
        let url_ = this.baseUrl + "/reset-password?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostPasswordReset(_response);
        });
    }

    protected processPostPasswordReset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = WrappedErrorInputError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return No content
     */
    postConfirmActiveDirectory(id: string, token: string): Promise<void> {
        let url_ = this.baseUrl + "/confirm-migration?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostConfirmActiveDirectory(_response);
        });
    }

    protected processPostConfirmActiveDirectory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = WrappedErrorInputError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body Contains information about updated user
     * @return No content
     */
    updateAccount(body: UpdateAccountRequest): Promise<void> {
        let url_ = this.baseUrl + "/update-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAccount(_response);
        });
    }

    protected processUpdateAccount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = WrappedErrorInputError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return No content
     */
    verifyEmail(id: string, token: string): Promise<void> {
        let url_ = this.baseUrl + "/verify-email?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyEmail(_response);
        });
    }

    protected processVerifyEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = WrappedErrorInputError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param workspaceId ID of workspace to assign imported object to
     * @param hostname Hostname of server to assign imported object to
     * @param secure Flag: Represents protocol of server (https or http)
     * @return No content
     */
    postXMLDatabase(workspaceId: string, hostname: string, secure: boolean, data : FormData ): Promise<void> {
        let url_ = this.baseUrl + "/import-db?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined and cannot be null.");
        else
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (hostname === undefined || hostname === null)
            throw new Error("The parameter 'hostname' must be defined and cannot be null.");
        else
            url_ += "hostname=" + encodeURIComponent("" + hostname) + "&";
        if (secure === undefined || secure === null)
            throw new Error("The parameter 'secure' must be defined and cannot be null.");
        else
            url_ += "secure=" + encodeURIComponent("" + secure) + "&";
        url_ = url_.replace(/[?&]$/, "");
     
        let options_ = <RequestInit>{
            body: data,
            credentials: 'same-origin',
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostXMLDatabase(_response);
        });
    }

    protected processPostXMLDatabase(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = WrappedErrorInputError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param host Hostname of server the request was made to
     * @return Ok
     */
    getSkin(host: string): Promise<AASTheme> {
        let url_ = this.baseUrl + "/find-skin/{host}";
        if (host === undefined || host === null)
            throw new Error("The parameter 'host' must be defined.");
        url_ = url_.replace("{host}", encodeURIComponent("" + host));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSkin(_response);
        });
    }

    protected processGetSkin(response: Response): Promise<AASTheme> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AASTheme.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AASTheme>(<any>null);
    }

    /**
     * @return Ok
     */
     getXMLDatabaseProgress(): Promise<any> {
        let url_ = this.baseUrl + "/import-db-progress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetXMLDatabaseProgress(_response);
        });
    }

    protected processGetXMLDatabaseProgress(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @return Ok
     */
    checkAppKey(key: string, user: string, application: string, hostname: string): Promise<string> {
        let url_ = this.baseUrl + "/checkAppKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "key": key !== undefined && key !== null ? "" + key : "",
                "user": user !== undefined && user !== null ? "" + user : "",
                "application": application !== undefined && application !== null ? "" + application : "",
                "hostname": hostname !== undefined && hostname !== null ? "" + hostname : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckAppKey(_response);
        });
    }

    protected processCheckAppKey(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return Ok
     */
    getCSRFToken(): Promise<Anonymous3> {
        let url_ = this.baseUrl + "/getCSRFToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCSRFToken(_response);
        });
    }

    protected processGetCSRFToken(response: Response): Promise<Anonymous3> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous3.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Anonymous3>(<any>null);
    }
}

export class ServersClient extends AuthWithCookies {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "localhost:3001/api";
    }

    /**
     * @param id hostname of server
     * @return Ok
     */
    getServer(id: string): Promise<Server> {
        let url_ = this.baseUrl + "/servers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServer(_response);
        });
    }

    protected processGetServer(response: Response): Promise<Server> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Server.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Server>(<any>null);
    }

    /**
     * @param id hostname of the server to update
     * @param body Updated properties
     * @return Ok
     */
    updateServer(id: string, body: ServerUpdateRequest): Promise<Server> {
        let url_ = this.baseUrl + "/servers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateServer(_response);
        });
    }

    protected processUpdateServer(response: Response): Promise<Server> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Server.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Server>(<any>null);
    }

    /**
     * @param id hostname of the server to delete
     * @return No content
     */
    deleteServer(id: string): Promise<void> {
        let url_ = this.baseUrl + "/servers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteServer(_response);
        });
    }

    protected processDeleteServer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param namesOnly (optional) Flag: if true, request a flat array of all visible servers withminimal information (so without assignments)
     * @param count (optional) Flag: if true, add field with count of all servers. Meant for paging
     * @param limit (optional) Limit the amount of servers returned to specified number. Meant for paging
     * @param start (optional) Starting index of limited request. Meant for paging
     * @param ordering (optional) List of properties with 'asc'/'desc' to order servers on
     * @param a (optional) List of application IDs to filter on
     * @param search (optional) Search string
     * @return Ok
     */
    getServers(namesOnly: boolean | null | undefined, count: boolean | null | undefined, limit: number | null | undefined, start: number | null | undefined, ordering: string | null | undefined, a: string[] | null | undefined, search: string | null | undefined): Promise<ServerCollection> {
        let url_ = this.baseUrl + "/servers?";
        if (namesOnly !== undefined && namesOnly !== null)
            url_ += "namesOnly=" + encodeURIComponent("" + namesOnly) + "&";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (ordering !== undefined && ordering !== null)
            url_ += "ordering=" + encodeURIComponent("" + ordering) + "&";
        if (a !== undefined && a !== null)
            a && a.forEach(item => { url_ += "a=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServers(_response);
        });
    }

    protected processGetServers(response: Response): Promise<ServerCollection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServerCollection.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServerCollection>(<any>null);
    }

    /**
     * @param body Server properties
     * @return Ok
     */
    createServer(body: ServerCreationRequest): Promise<Server> {
        let url_ = this.baseUrl + "/servers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateServer(_response);
        });
    }

    protected processCreateServer(response: Response): Promise<Server> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Server.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Server>(<any>null);
    }

    /**
     * @param body Has list of server hostnames
     * @return Ok
     */
    generateNewServerKey(body: ServerNewKeyRequest): Promise<Server[]> {
        let url_ = this.baseUrl + "/servers/newKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateNewServerKey(_response);
        });
    }

    protected processGenerateNewServerKey(response: Response): Promise<Server[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Server.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Server[]>(<any>null);
    }

    /**
     * @param body Has list of server hostnames to delete
     * @return No content
     */
    bulkDeleteServers(body: ServerBulkDeleteRequest): Promise<void> {
        let url_ = this.baseUrl + "/servers/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeleteServers(_response);
        });
    }

    protected processBulkDeleteServers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param hostname hostname of the server
     * @return Ok
     */
    getMaintenanceMode2(hostname: string): Promise<boolean> {
        let url_ = this.baseUrl + "/servers/maintenanceMode/{hostname}";
        if (hostname === undefined || hostname === null)
            throw new Error("The parameter 'hostname' must be defined.");
        url_ = url_.replace("{hostname}", encodeURIComponent("" + hostname));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMaintenanceMode2(_response);
        });
    }

    protected processGetMaintenanceMode2(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param hostname hostname of the server
     * @param body contains new value
     * @return Ok
     */
    setMaintenanceMode2(hostname: string, body: ServerMaintenanceModeRequest): Promise<boolean> {
        let url_ = this.baseUrl + "/servers/maintenanceMode/{hostname}";
        if (hostname === undefined || hostname === null)
            throw new Error("The parameter 'hostname' must be defined.");
        url_ = url_.replace("{hostname}", encodeURIComponent("" + hostname));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetMaintenanceMode2(_response);
        });
    }

    protected processSetMaintenanceMode2(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class Privilege implements IPrivilege {
    name!: string;
    parent?: Privilege | undefined;
    children?: Privilege[] | undefined;

    constructor(data?: IPrivilege) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.parent = _data["parent"] ? Privilege.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Privilege.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Privilege {
        data = typeof data === 'object' ? data : {};
        let result = new Privilege();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPrivilege {
    name: string;
    parent?: Privilege | undefined;
    children?: Privilege[] | undefined;
}

export class User implements IUser {
    id!: string;
    username?: string | undefined;
    email?: string | undefined;
    ad_identifier?: string | undefined;
    first_name!: string;
    last_name!: string;
    is_old_user!: boolean;
    active!: boolean;
    verified!: boolean;
    applications?: Applications[] | undefined;
    groups?: Groups[] | undefined;
    org_unit?: string | undefined;
    workspace?: Workspace2 | undefined;
    privileges?: Privileges[] | undefined;
    createdAt?:  Date | undefined;
    last_login?: Date | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.ad_identifier = _data["ad_identifier"];
            this.first_name = _data["first_name"];
            this.last_name = _data["last_name"];
            this.is_old_user = _data["is_old_user"];
            this.active = _data["active"];
            this.verified = _data["verified"];
            this.org_unit = _data["org_unit"];
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(Applications.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(Groups.fromJS(item));
            }
            this.workspace = _data["workspace"] ? Workspace2.fromJS(_data["workspace"]) : <any>undefined;
            if (Array.isArray(_data["privileges"])) {
                this.privileges = [] as any;
                for (let item of _data["privileges"])
                    this.privileges!.push(Privileges.fromJS(item));
            }
            this.last_login = _data["last_login"] ? new Date(_data["last_login"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["email"] = this.email;
        data["ad_identifier"] = this.ad_identifier;
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        data["is_old_user"] = this.is_old_user;
        data["active"] = this.active;
        data["verified"] = this.verified;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        data["workspace"] = this.workspace ? this.workspace.toJSON() : <any>undefined;
        if (Array.isArray(this.privileges)) {
            data["privileges"] = [];
            for (let item of this.privileges)
                data["privileges"].push(item.toJSON());
        }
        data["last_login"] = this.last_login ? this.last_login.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUser {
    id: string;
    username?: string | undefined;
    email?: string | undefined;
    ad_identifier?: string | undefined;
    first_name: string;
    last_name: string;
    is_old_user: boolean;
    active: boolean;
    verified: boolean;
    applications?: Applications[] | undefined;
    groups?: Groups[] | undefined;
    workspace?: Workspace2 | undefined;
    privileges?: Privileges[] | undefined;
    last_login?: Date | undefined;
    createdAt?: Date | undefined;
}

export class Ordering implements IOrdering {
    column!: string;
    order!: OrderingOrder;

    constructor(data?: IOrdering) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.column = _data["column"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): Ordering {
        data = typeof data === 'object' ? data : {};
        let result = new Ordering();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["column"] = this.column;
        data["order"] = this.order;
        return data; 
    }
}

export interface IOrdering {
    column: string;
    order: OrderingOrder;
}

export class UserCollection implements IUserCollection {
    items!: User[];
    count?: number | undefined;
    ordering?: Ordering[] | undefined;
    start?: number | undefined;
    limit?: number | undefined;
    filter?: Filter | undefined;

    constructor(data?: IUserCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(User.fromJS(item));
            }
            this.count = _data["count"];
            if (Array.isArray(_data["ordering"])) {
                this.ordering = [] as any;
                for (let item of _data["ordering"])
                    this.ordering!.push(Ordering.fromJS(item));
            }
            this.start = _data["start"];
            this.limit = _data["limit"];
            this.filter = _data["filter"] ? Filter.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserCollection {
        data = typeof data === 'object' ? data : {};
        let result = new UserCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["count"] = this.count;
        if (Array.isArray(this.ordering)) {
            data["ordering"] = [];
            for (let item of this.ordering)
                data["ordering"].push(item.toJSON());
        }
        data["start"] = this.start;
        data["limit"] = this.limit;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUserCollection {
    items: User[];
    count?: number | undefined;
    ordering?: Ordering[] | undefined;
    start?: number | undefined;
    limit?: number | undefined;
    filter?: Filter | undefined;
}

export enum ErrorCode {
    INPUT_ERROR = "INPUT_ERROR",
    ValidateError = "ValidateError",
    FORBIDDEN = "FORBIDDEN",
    NOT_FOUND = "NOT_FOUND",
    UNAUTHORIZED = "UNAUTHORIZED",
    AUTH_ERROR = "AUTH_ERROR",
    SERVER_ERROR = "SERVER_ERROR",
    MAINTENANCE_MODE = "MAINTENANCE_MODE"
}

export class ForbiddenError implements IForbiddenError {
    stack?: string | undefined;
    statusCode!: number;
    errorCode!: ErrorCode;
    redirectHost!: string;

    constructor(data?: IForbiddenError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stack = _data["stack"];
            this.statusCode = _data["statusCode"];
            this.errorCode = _data["errorCode"];
            this.redirectHost = _data["redirectHost"];
        }
    }

    static fromJS(data: any): ForbiddenError {
        data = typeof data === 'object' ? data : {};
        let result = new ForbiddenError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stack"] = this.stack;
        data["statusCode"] = this.statusCode;
        data["errorCode"] = this.errorCode;
        data["redirectHost"] = this.redirectHost;
        return data; 
    }
}

export interface IForbiddenError {
    stack?: string | undefined;
    statusCode: number;
    errorCode: ErrorCode;
    redirectHost: string;
}

export class WrappedErrorForbiddenError implements IWrappedErrorForbiddenError {
    error!: ForbiddenError;

    constructor(data?: IWrappedErrorForbiddenError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.error = new ForbiddenError();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] ? ForbiddenError.fromJS(_data["error"]) : new ForbiddenError();
        }
    }

    static fromJS(data: any): WrappedErrorForbiddenError {
        data = typeof data === 'object' ? data : {};
        let result = new WrappedErrorForbiddenError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IWrappedErrorForbiddenError {
    error: ForbiddenError;
}

export class UserCreationRequest implements IUserCreationRequest {
    email!: string;
    ad_identifier?: string | undefined;
    first_name!: string;
    last_name!: string;
    active?: boolean | undefined;
    applications?: Applications2[] | undefined;
    groups?: Groups2[] | undefined;
    workspace?: string | undefined;
    privileges?: Privileges2[] | undefined;
    mailUser?: boolean | undefined;

    constructor(data?: IUserCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.ad_identifier = _data["ad_identifier"];
            this.first_name = _data["first_name"];
            this.last_name = _data["last_name"];
            this.active = _data["active"];
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(Applications2.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(Groups2.fromJS(item));
            }
            this.workspace = _data["workspace"];
            if (Array.isArray(_data["privileges"])) {
                this.privileges = [] as any;
                for (let item of _data["privileges"])
                    this.privileges!.push(Privileges2.fromJS(item));
            }
            this.mailUser = _data["mailUser"];
        }
    }

    static fromJS(data: any): UserCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["ad_identifier"] = this.ad_identifier;
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        data["active"] = this.active;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        data["workspace"] = this.workspace;
        if (Array.isArray(this.privileges)) {
            data["privileges"] = [];
            for (let item of this.privileges)
                data["privileges"].push(item.toJSON());
        }
        data["mailUser"] = this.mailUser;
        return data; 
    }
}

export interface IUserCreationRequest {
    email: string;
    ad_identifier?: string | undefined;
    first_name: string;
    last_name: string;
    active?: boolean | undefined;
    applications?: Applications2[] | undefined;
    groups?: Groups2[] | undefined;
    workspace?: string | undefined;
    privileges?: Privileges2[] | undefined;
    mailUser?: boolean | undefined;
}

export class UserUpdateRequest implements IUserUpdateRequest {
    username?: string | undefined;
    email?: string | undefined;
    ad_identifier?: string | undefined;
    org_unit?: string | undefined;
    first_name?: string | undefined;
    last_name?: string | undefined;
    active?: boolean | undefined;
    applications?: Applications3[] | undefined;
    groups?: Groups3[] | undefined;
    workspace?: string | undefined;
    privileges?: Privileges3[] | undefined;
    mailUser?: boolean | undefined;

    constructor(data?: IUserUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.email = _data["email"];
            this.ad_identifier = _data["ad_identifier"];
            this.org_unit = _data["org_unit"];
            this.first_name = _data["first_name"];
            this.last_name = _data["last_name"];
            this.active = _data["active"];
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(Applications3.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(Groups3.fromJS(item));
            }
            this.workspace = _data["workspace"];
            if (Array.isArray(_data["privileges"])) {
                this.privileges = [] as any;
                for (let item of _data["privileges"])
                    this.privileges!.push(Privileges3.fromJS(item));
            }
            this.mailUser = _data["mailUser"];
        }
    }

    static fromJS(data: any): UserUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["email"] = this.email;
        data["ad_identifier"] = this.ad_identifier;
        data["org_unit"] = this.org_unit;
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        data["active"] = this.active;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        data["workspace"] = this.workspace;
        if (Array.isArray(this.privileges)) {
            data["privileges"] = [];
            for (let item of this.privileges)
                data["privileges"].push(item.toJSON());
        }
        data["mailUser"] = this.mailUser;
        return data; 
    }
}

export interface IUserUpdateRequest {
    username?: string | undefined;
    email?: string | undefined;
    ad_identifier?: string | undefined;
    org_unit?: string | undefined;
    first_name?: string | undefined;
    last_name?: string | undefined;
    active?: boolean | undefined;
    applications?: Applications3[] | undefined;
    groups?: Groups3[] | undefined;
    workspace?: string | undefined;
    privileges?: Privileges3[] | undefined;
    mailUser?: boolean | undefined;
}

export class UserBulkDeleteRequest implements IUserBulkDeleteRequest {
    ids!: string[];

    constructor(data?: IUserBulkDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): UserBulkDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserBulkDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IUserBulkDeleteRequest {
    ids: string[];
}

export class UserBulkAssignGroupRequest implements IUserBulkAssignGroupRequest {
    users!: string[];
    groups!: string[];

    constructor(data?: IUserBulkAssignGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.users = [];
            this.groups = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(item);
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
        }
    }

    static fromJS(data: any): UserBulkAssignGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserBulkAssignGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item);
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        return data; 
    }
}

export interface IUserBulkAssignGroupRequest {
    users: string[];
    groups: string[];
}

export class UserBulkAssignApplicationRequest implements IUserBulkAssignApplicationRequest {
    users!: string[];
    applications!: string[];

    constructor(data?: IUserBulkAssignApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.users = [];
            this.applications = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(item);
            }
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(item);
            }
        }
    }

    static fromJS(data: any): UserBulkAssignApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserBulkAssignApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item);
        }
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item);
        }
        return data; 
    }
}

export interface IUserBulkAssignApplicationRequest {
    users: string[];
    applications: string[];
}

export class UserCreateApplicationKeyRequest implements IUserCreateApplicationKeyRequest {
    users!: string[];
    application!: string;

    constructor(data?: IUserCreateApplicationKeyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(item);
            }
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): UserCreateApplicationKeyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateApplicationKeyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item);
        }
        data["application"] = this.application;
        return data; 
    }
}

export interface IUserCreateApplicationKeyRequest {
    users: string[];
    application: string;
}

export class UserBulkAssignWorkspaceRequest implements IUserBulkAssignWorkspaceRequest {
    users!: string[];
    workspace!: string;

    constructor(data?: IUserBulkAssignWorkspaceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(item);
            }
            this.workspace = _data["workspace"];
        }
    }

    static fromJS(data: any): UserBulkAssignWorkspaceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserBulkAssignWorkspaceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item);
        }
        data["workspace"] = this.workspace;
        return data; 
    }
}

export interface IUserBulkAssignWorkspaceRequest {
    users: string[];
    workspace: string;
}

export class UserSynchronizeRequest implements IUserSynchronizeRequest {
    ids!: string[];

    constructor(data?: IUserSynchronizeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): UserSynchronizeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserSynchronizeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IUserSynchronizeRequest {
    ids: string[];
}

export class UserBulkActivateRequest implements IUserBulkActivateRequest {
    ids!: string[];

    constructor(data?: IUserBulkActivateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): UserBulkActivateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserBulkActivateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IUserBulkActivateRequest {
    ids: string[];
}

export class UserBulkUpdateAD implements IUserBulkUpdateAD {
    ids!: string[];

    constructor(data?: IUserBulkUpdateAD) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): UserBulkUpdateAD {
        data = typeof data === 'object' ? data : {};
        let result = new UserBulkUpdateAD();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IUserBulkUpdateAD {
    ids: string[];
}

export class UserBulkDeactivateRequest implements IUserBulkDeactivateRequest {
    ids!: string[];

    constructor(data?: IUserBulkDeactivateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): UserBulkDeactivateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserBulkDeactivateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IUserBulkDeactivateRequest {
    ids: string[];
}

export enum MailTypes {
    NewUser = "NewUser",
    NewSSOUser = "NewSSOUser",
    ResetPassword = "ResetPassword",
    MigrateAccount = "MigrateAccount",
    MigratePassword = "MigratePassword",
    MigrateActiveDirectory = "MigrateActiveDirectory",
    VerifyEmail = "VerifyEmail",
}

export class UserBulkMailRequest implements IUserBulkMailRequest {
    mailType!: MailTypes;
    ids!: string[];

    constructor(data?: IUserBulkMailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailType = _data["mailType"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): UserBulkMailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserBulkMailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailType"] = this.mailType;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IUserBulkMailRequest {
    mailType: MailTypes;
    ids: string[];
}

export class ImportCSVRequest implements IImportCSVRequest {
    csv!: string;
    options!: Options;

    constructor(data?: IImportCSVRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.options = new Options();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.csv = _data["csv"];
            this.options = _data["options"] ? Options.fromJS(_data["options"]) : new Options();
        }
    }

    static fromJS(data: any): ImportCSVRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCSVRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["csv"] = this.csv;
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IImportCSVRequest {
    csv: string;
    options: Options;
}

export class ApplicationStatus implements IApplicationStatus {
    name!: string;
    status!: string;
    importance!: number;
    numberOfQueuedActions!: number;
    numberOfQueuedExecModelActions!: number;

    constructor(data?: IApplicationStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.status = _data["status"];
            this.importance = _data["importance"];
            this.numberOfQueuedActions = _data["numberOfQueuedActions"];
            this.numberOfQueuedExecModelActions = _data["numberOfQueuedExecModelActions"];
        }
    }

    static fromJS(data: any): ApplicationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["status"] = this.status;
        data["importance"] = this.importance;
        data["numberOfQueuedActions"] = this.numberOfQueuedActions;
        data["numberOfQueuedExecModelActions"] = this.numberOfQueuedExecModelActions;
        return data; 
    }
}

export interface IApplicationStatus {
    name: string;
    status: string;
    importance: number;
    numberOfQueuedActions: number;
    numberOfQueuedExecModelActions: number;
}

export class Application implements IApplication {
    id!: string;
    title!: string;
    location_path!: string;
    server!: Server2;
    help_url!: string;
    color!: string;
    no_login_as!: boolean;
    users?: Users[] | undefined;
    workspace?: Workspace3 | undefined;
    status?: ApplicationStatus | undefined;
    maintenanceMode?: boolean | undefined;
    server_alias!: string;

    constructor(data?: IApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.server = new Server2();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.location_path = _data["location_path"];
            this.server = _data["server"] ? Server2.fromJS(_data["server"]) : new Server2();
            this.help_url = _data["help_url"];
            this.color = _data["color"];
            this.no_login_as = _data["no_login_as"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(Users.fromJS(item));
            }
            this.workspace = _data["workspace"] ? Workspace3.fromJS(_data["workspace"]) : <any>undefined;
            this.status = _data["status"] ? ApplicationStatus.fromJS(_data["status"]) : <any>undefined;
            this.maintenanceMode = _data["maintenanceMode"];
            this.server_alias = _data["server_alias"];
        }
    }

    static fromJS(data: any): Application {
        data = typeof data === 'object' ? data : {};
        let result = new Application();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["location_path"] = this.location_path;
        data["server"] = this.server ? this.server.toJSON() : <any>undefined;
        data["help_url"] = this.help_url;
        data["color"] = this.color;
        data["no_login_as"] = this.no_login_as;
        data["server_alias"] = this.server_alias;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["workspace"] = this.workspace ? this.workspace.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["maintenanceMode"] = this.maintenanceMode;
        return data; 
    }
}

export interface IApplication {
    id: string;
    title: string;
    location_path: string;
    server: Server2;
    help_url: string;
    color: string;
    no_login_as: boolean;
    server_alias: string;
    users?: Users[] | undefined;
    workspace?: Workspace3 | undefined;
    status?: ApplicationStatus | undefined;
    maintenanceMode?: boolean | undefined;
}

export class ApplicationCollection implements IApplicationCollection {
    items!: Application[];
    count?: number | undefined;
    ordering?: Ordering[] | undefined;
    start?: number | undefined;
    limit?: number | undefined;
    filter?: Filter2 | undefined;

    constructor(data?: IApplicationCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Application.fromJS(item));
            }
            this.count = _data["count"];
            if (Array.isArray(_data["ordering"])) {
                this.ordering = [] as any;
                for (let item of _data["ordering"])
                    this.ordering!.push(Ordering.fromJS(item));
            }
            this.start = _data["start"];
            this.limit = _data["limit"];
            this.filter = _data["filter"] ? Filter2.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationCollection {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["count"] = this.count;
        if (Array.isArray(this.ordering)) {
            data["ordering"] = [];
            for (let item of this.ordering)
                data["ordering"].push(item.toJSON());
        }
        data["start"] = this.start;
        data["limit"] = this.limit;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IApplicationCollection {
    items: Application[];
    count?: number | undefined;
    ordering?: Ordering[] | undefined;
    start?: number | undefined;
    limit?: number | undefined;
    filter?: Filter2 | undefined;
}

export class ApplicationCreationRequest implements IApplicationCreationRequest {
    title!: string;
    location_path!: string;
    serverHostname!: string;
    help_url!: string;
    color!: string;
    server_alias?: string;
    no_login_as?: boolean | undefined;
    workspace?: string | undefined;

    constructor(data?: IApplicationCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.location_path = _data["location_path"];
            this.serverHostname = _data["serverHostname"];
            this.help_url = _data["help_url"];
            this.color = _data["color"];
            this.server_alias = _data["server_alias"];
            this.no_login_as = _data["no_login_as"];
            this.workspace = _data["workspace"];
        }
    }

    static fromJS(data: any): ApplicationCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["location_path"] = this.location_path;
        data["serverHostname"] = this.serverHostname;
        data["help_url"] = this.help_url;
        data["color"] = this.color;
        data["server_alias"] = this.server_alias;
        data["no_login_as"] = this.no_login_as;
        data["workspace"] = this.workspace;
        return data; 
    }
}

export interface IApplicationCreationRequest {
    title: string;
    location_path: string;
    serverHostname: string;
    help_url: string;
    color: string;
    server_alias?: string | undefined;
    no_login_as?: boolean | undefined;
    workspace?: string | undefined;
}

export class ApplicationUpdateRequest implements IApplicationUpdateRequest {
    title?: string | undefined;
    location_path?: string | undefined;
    serverHostname?: string | undefined;
    help_url?: string | undefined;
    color?: string | undefined;
    server_alias?: string | undefined;
    no_login_as?: boolean | undefined;
    workspace?: string | undefined;

    constructor(data?: IApplicationUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.location_path = _data["location_path"];
            this.serverHostname = _data["serverHostname"];
            this.help_url = _data["help_url"];
            this.color = _data["color"];
            this.server_alias = _data["server_alias"];
            this.no_login_as = _data["no_login_as"];
            this.workspace = _data["workspace"];
        }
    }

    static fromJS(data: any): ApplicationUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["location_path"] = this.location_path;
        data["serverHostname"] = this.serverHostname;
        data["help_url"] = this.help_url;
        data["color"] = this.color;
        data["server_alias"] = this.server_alias;
        data["no_login_as"] = this.no_login_as;
        data["workspace"] = this.workspace;
        return data; 
    }
}

export interface IApplicationUpdateRequest {
    title?: string | undefined;
    location_path?: string | undefined;
    serverHostname?: string | undefined;
    help_url?: string | undefined;
    color?: string | undefined;
    server_alias?: string | undefined;
    no_login_as?: boolean | undefined;
    workspace?: string | undefined;
}

export class ApplicationBulkDeleteRequest implements IApplicationBulkDeleteRequest {
    ids!: string[];

    constructor(data?: IApplicationBulkDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ApplicationBulkDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationBulkDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IApplicationBulkDeleteRequest {
    ids: string[];
}

export class ApplicationBulkAssignWorkspaceRequest implements IApplicationBulkAssignWorkspaceRequest {
    applications!: string[];
    workspace!: string;

    constructor(data?: IApplicationBulkAssignWorkspaceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applications = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(item);
            }
            this.workspace = _data["workspace"];
        }
    }

    static fromJS(data: any): ApplicationBulkAssignWorkspaceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationBulkAssignWorkspaceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item);
        }
        data["workspace"] = this.workspace;
        return data; 
    }
}

export interface IApplicationBulkAssignWorkspaceRequest {
    applications: string[];
    workspace: string;
}

export class ApplicationSynchronizeRequest implements IApplicationSynchronizeRequest {
    ids!: string[];

    constructor(data?: IApplicationSynchronizeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ApplicationSynchronizeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationSynchronizeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IApplicationSynchronizeRequest {
    ids: string[];
}

export class ApplicationMaintenanceModeRequest implements IApplicationMaintenanceModeRequest {
    value!: boolean;

    constructor(data?: IApplicationMaintenanceModeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ApplicationMaintenanceModeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationMaintenanceModeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data; 
    }
}

export interface IApplicationMaintenanceModeRequest {
    value: boolean;
}

export class Group implements IGroup {
    id!: string;
    name!: string;
    users?: Users2[] | undefined;
    workspaces?: Workspaces[] | undefined;

    constructor(data?: IGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(Users2.fromJS(item));
            }
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(Workspaces.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Group {
        data = typeof data === 'object' ? data : {};
        let result = new Group();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGroup {
    id: string;
    name: string;
    users?: Users2[] | undefined;
    workspaces?: Workspaces[] | undefined;
}

export class GroupCollection implements IGroupCollection {
    items!: Group[];
    count?: number | undefined;
    ordering?: Ordering[] | undefined;
    start?: number | undefined;
    limit?: number | undefined;
    filter?: Filter3 | undefined;

    constructor(data?: IGroupCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Group.fromJS(item));
            }
            this.count = _data["count"];
            if (Array.isArray(_data["ordering"])) {
                this.ordering = [] as any;
                for (let item of _data["ordering"])
                    this.ordering!.push(Ordering.fromJS(item));
            }
            this.start = _data["start"];
            this.limit = _data["limit"];
            this.filter = _data["filter"] ? Filter3.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GroupCollection {
        data = typeof data === 'object' ? data : {};
        let result = new GroupCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["count"] = this.count;
        if (Array.isArray(this.ordering)) {
            data["ordering"] = [];
            for (let item of this.ordering)
                data["ordering"].push(item.toJSON());
        }
        data["start"] = this.start;
        data["limit"] = this.limit;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGroupCollection {
    items: Group[];
    count?: number | undefined;
    ordering?: Ordering[] | undefined;
    start?: number | undefined;
    limit?: number | undefined;
    filter?: Filter3 | undefined;
}

export class GroupCreationRequest implements IGroupCreationRequest {
    name!: string;
    workspaces?: Workspaces2[] | undefined;

    constructor(data?: IGroupCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(Workspaces2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GroupCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGroupCreationRequest {
    name: string;
    workspaces?: Workspaces2[] | undefined;
}

export class GroupUpdateRequest implements IGroupUpdateRequest {
    name?: string | undefined;
    workspaces?: Workspaces3[] | undefined;

    constructor(data?: IGroupUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(Workspaces3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GroupUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGroupUpdateRequest {
    name?: string | undefined;
    workspaces?: Workspaces3[] | undefined;
}

export class GroupBulkDeleteRequest implements IGroupBulkDeleteRequest {
    ids!: string[];

    constructor(data?: IGroupBulkDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): GroupBulkDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GroupBulkDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IGroupBulkDeleteRequest {
    ids: string[];
}

export class GroupBulkAssignWorkspacesRequest implements IGroupBulkAssignWorkspacesRequest {
    groups!: string[];
    workspaces!: string[];

    constructor(data?: IGroupBulkAssignWorkspacesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.groups = [];
            this.workspaces = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(item);
            }
        }
    }

    static fromJS(data: any): GroupBulkAssignWorkspacesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GroupBulkAssignWorkspacesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item);
        }
        return data; 
    }
}

export interface IGroupBulkAssignWorkspacesRequest {
    groups: string[];
    workspaces: string[];
}

export class Workspace implements IWorkspace {
    id!: string;
    name!: string;
    ip_restricted!: boolean;
    host!: string;
    accent_color!: string;
    background_img!: string;
    icon_img!: string;
    logo_img!: string;
    org_name!: string;
    favicon!: string;
    user_limit?: number | undefined;
    user_count? : string | undefined;
    app_count? : string  | undefined;
    sso_callback!: string;
    sso_logout!: string;
    sso_logoutcallback!: string;
    sso_entrypoint!: string;
    sso_issuer!: string;
    sso_certificate!: string;
    sso_public_key!: string;
    sso_private_key!: string;
    mail_template!: string;
    etl_url!: string;
    parent?: Parent | undefined;
    applications?: Applications4[] | undefined;
    groups?: Groups4[] | undefined;
    users?: Users3[] | undefined;

    constructor(data?: IWorkspace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ip_restricted = _data["ip_restricted"];
            this.host = _data["host"];
            this.accent_color = _data["accent_color"];
            this.background_img = _data["background_img"];
            this.icon_img = _data["icon_img"];
            this.logo_img = _data["logo_img"];
            this.org_name = _data["org_name"];
            this.favicon = _data["favicon"];
            this.user_limit = _data["user_limit"];          
            if (Array.isArray(_data["workspaces_counts"])) {
                this.user_count = _data["workspaces_counts"][0]["user_count"];
                this.app_count= _data["workspaces_counts"][0]["app_count"]; 
            }

           
            this.sso_callback = _data["sso_callback"];
            this.sso_logout = _data["sso_logout"];
            this.sso_logoutcallback = _data["sso_logoutcallback"];
            this.sso_entrypoint = _data["sso_entrypoint"];
            this.sso_issuer = _data["sso_issuer"];
            this.sso_certificate = _data["sso_certificate"];
            this.sso_public_key = _data["sso_public_key"];
            this.sso_private_key = _data["sso_private_key"];
            this.mail_template = _data["mail_template"];
            this.etl_url = _data["etl_url"];
            this.parent = _data["parent"] ? Parent.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(Applications4.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(Groups4.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(Users3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Workspace {
        data = typeof data === 'object' ? data : {};
        let result = new Workspace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ip_restricted"] = this.ip_restricted;
        data["host"] = this.host;
        data["accent_color"] = this.accent_color;
        data["background_img"] = this.background_img;
        data["icon_img"] = this.icon_img;
        data["logo_img"] = this.logo_img;
        data["org_name"] = this.org_name;
        data["favicon"] = this.favicon;
        data["user_limit"] = this.user_limit;
        data["user_count"] = this.user_count;
        data["app_count"] = this.app_count;
        data["sso_callback"] = this.sso_callback;
        data["sso_logout"] = this.sso_logout;
        data["sso_logoutcallback"] = this.sso_logoutcallback;
        data["sso_entrypoint"] = this.sso_entrypoint;
        data["sso_issuer"] = this.sso_issuer;
        data["sso_certificate"] = this.sso_certificate;
        data["sso_public_key"] = this.sso_public_key;
        data["sso_private_key"] = this.sso_private_key;
        data["mail_template"] = this.mail_template;
        data["etl_url"] = this.etl_url;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorkspace {
    id: string;
    name: string;
    ip_restricted: boolean;
    host: string;
    accent_color: string;
    background_img: string;
    icon_img: string;
    logo_img: string;
    org_name: string;
    favicon: string;
    user_limit?: number | undefined;
    sso_callback: string;
    sso_logout: string;
    sso_logoutcallback: string;
    sso_entrypoint: string;
    sso_issuer: string;
    sso_certificate: string;
    sso_public_key: string;
    sso_private_key: string;
    mail_template: string;
    etl_url: string;
    parent?: Parent | undefined;
    applications?: Applications4[] | undefined;
    groups?: Groups4[] | undefined;
    users?: Users3[] | undefined;
}

export class WorkspaceCollection implements IWorkspaceCollection {
    items!: Workspace[];
    count?: number | undefined;
    ordering?: Ordering[] | undefined;
    start?: number | undefined;
    limit?: number | undefined;
    filter?: Filter4 | undefined;

    constructor(data?: IWorkspaceCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Workspace.fromJS(item));
            }
            this.count = _data["count"];
            if (Array.isArray(_data["ordering"])) {
                this.ordering = [] as any;
                for (let item of _data["ordering"])
                    this.ordering!.push(Ordering.fromJS(item));
            }
            this.start = _data["start"];
            this.limit = _data["limit"];
            this.filter = _data["filter"] ? Filter4.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkspaceCollection {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["count"] = this.count;
        if (Array.isArray(this.ordering)) {
            data["ordering"] = [];
            for (let item of this.ordering)
                data["ordering"].push(item.toJSON());
        }
        data["start"] = this.start;
        data["limit"] = this.limit;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IWorkspaceCollection {
    items: Workspace[];
    count?: number | undefined;
    ordering?: Ordering[] | undefined;
    start?: number | undefined;
    limit?: number | undefined;
    filter?: Filter4 | undefined;
}

export class WorkspaceCreationRequest implements IWorkspaceCreationRequest {
    name!: string;
    ip_restricted!: boolean;
    host!: string;
    accent_color!: string;
    background_img!: string;
    icon_img!: string;
    logo_img!: string;
    org_name!: string;
    favicon!: string;
    user_limit?: number | undefined;
    sso_callback!: string;
    sso_logout!: string;
    sso_logoutcallback!: string;
    sso_entrypoint!: string;
    sso_issuer!: string;
    sso_certificate!: string;
    sso_public_key!: string;
    sso_private_key!: string;
    mail_template!: string;
    etl_url!: string;
    parent_id?: string | undefined;
    groups?: Groups5[] | undefined;

    constructor(data?: IWorkspaceCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.ip_restricted = _data["ip_restricted"];
            this.host = _data["host"];
            this.accent_color = _data["accent_color"];
            this.background_img = _data["background_img"];
            this.icon_img = _data["icon_img"];
            this.logo_img = _data["logo_img"];
            this.org_name = _data["org_name"];
            this.favicon = _data["favicon"];
            this.user_limit = _data["user_limit"];
            this.sso_callback = _data["sso_callback"];
            this.sso_logout = _data["sso_logout"];
            this.sso_logoutcallback = _data["sso_logoutcallback"];
            this.sso_entrypoint = _data["sso_entrypoint"];
            this.sso_issuer = _data["sso_issuer"];
            this.sso_certificate = _data["sso_certificate"];
            this.sso_public_key = _data["sso_public_key"];
            this.sso_private_key = _data["sso_private_key"];
            this.mail_template = _data["mail_template"];
            this.etl_url = _data["etl_url"];
            this.parent_id = _data["parent_id"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(Groups5.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkspaceCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ip_restricted"] = this.ip_restricted;
        data["host"] = this.host;
        data["accent_color"] = this.accent_color;
        data["background_img"] = this.background_img;
        data["icon_img"] = this.icon_img;
        data["logo_img"] = this.logo_img;
        data["org_name"] = this.org_name;
        data["favicon"] = this.favicon;
        data["user_limit"] = this.user_limit;
        data["sso_callback"] = this.sso_callback;
        data["sso_logout"] = this.sso_logout;
        data["sso_logoutcallback"] = this.sso_logoutcallback;
        data["sso_entrypoint"] = this.sso_entrypoint;
        data["sso_issuer"] = this.sso_issuer;
        data["sso_certificate"] = this.sso_certificate;
        data["sso_public_key"] = this.sso_public_key;
        data["sso_private_key"] = this.sso_private_key;
        data["mail_template"] = this.mail_template;
        data["etl_url"] = this.etl_url;
        data["parent_id"] = this.parent_id;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorkspaceCreationRequest {
    name: string;
    ip_restricted: boolean;
    host: string;
    accent_color: string;
    background_img: string;
    icon_img: string;
    logo_img: string;
    org_name: string;
    favicon: string;
    user_limit?: number | undefined;
    sso_callback: string;
    sso_logout: string;
    sso_logoutcallback: string;
    sso_entrypoint: string;
    sso_issuer: string;
    sso_certificate: string;
    sso_public_key: string;
    sso_private_key: string;
    mail_template: string;
    etl_url: string;
    parent_id?: string | undefined;
    groups?: Groups5[] | undefined;
}

export class WorkspaceUpdateRequest implements IWorkspaceUpdateRequest {
    name?: string | undefined;
    ip_restricted?: boolean | undefined;
    host?: string | undefined;
    accent_color?: string | undefined;
    background_img?: string | undefined;
    icon_img?: string | undefined;
    logo_img?: string | undefined;
    org_name?: string | undefined;
    favicon?: string | undefined;
    user_limit?: number | undefined;
    sso_callback?: string | undefined;
    sso_logout?: string | undefined;
    sso_logoutcallback?: string | undefined;
    sso_entrypoint?: string | undefined;
    sso_issuer?: string | undefined;
    sso_certificate?: string | undefined;
    sso_public_key?: string | undefined;
    sso_private_key?: string | undefined;
    mail_template?: string | undefined;
    etl_url?: string | undefined;
    parent_id?: string | undefined;
    groups?: Groups6[] | undefined;

    constructor(data?: IWorkspaceUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.ip_restricted = _data["ip_restricted"];
            this.host = _data["host"];
            this.accent_color = _data["accent_color"];
            this.background_img = _data["background_img"];
            this.icon_img = _data["icon_img"];
            this.logo_img = _data["logo_img"];
            this.org_name = _data["org_name"];
            this.favicon = _data["favicon"];
            this.user_limit = _data["user_limit"];
            this.sso_callback = _data["sso_callback"];
            this.sso_logout = _data["sso_logout"];
            this.sso_logoutcallback = _data["sso_logoutcallback"];
            this.sso_entrypoint = _data["sso_entrypoint"];
            this.sso_issuer = _data["sso_issuer"];
            this.sso_certificate = _data["sso_certificate"];
            this.sso_public_key = _data["sso_public_key"];
            this.sso_private_key = _data["sso_private_key"];
            this.mail_template = _data["mail_template"];
            this.etl_url = _data["etl_url"];
            this.parent_id = _data["parent_id"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(Groups6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkspaceUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ip_restricted"] = this.ip_restricted;
        data["host"] = this.host;
        data["accent_color"] = this.accent_color;
        data["background_img"] = this.background_img;
        data["icon_img"] = this.icon_img;
        data["logo_img"] = this.logo_img;
        data["org_name"] = this.org_name;
        data["favicon"] = this.favicon;
        data["user_limit"] = this.user_limit;
        data["sso_callback"] = this.sso_callback;
        data["sso_logout"] = this.sso_logout;
        data["sso_logoutcallback"] = this.sso_logoutcallback;
        data["sso_entrypoint"] = this.sso_entrypoint;
        data["sso_issuer"] = this.sso_issuer;
        data["sso_certificate"] = this.sso_certificate;
        data["sso_public_key"] = this.sso_public_key;
        data["sso_private_key"] = this.sso_private_key;
        data["mail_template"] = this.mail_template;
        data["etl_url"] = this.etl_url;
        data["parent_id"] = this.parent_id;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorkspaceUpdateRequest {
    name?: string | undefined;
    ip_restricted?: boolean | undefined;
    host?: string | undefined;
    accent_color?: string | undefined;
    background_img?: string | undefined;
    icon_img?: string | undefined;
    logo_img?: string | undefined;
    org_name?: string | undefined;
    favicon?: string | undefined;
    user_limit?: number | undefined;
    sso_callback?: string | undefined;
    sso_logout?: string | undefined;
    sso_logoutcallback?: string | undefined;
    sso_entrypoint?: string | undefined;
    sso_issuer?: string | undefined;
    sso_certificate?: string | undefined;
    sso_public_key?: string | undefined;
    sso_private_key?: string | undefined;
    mail_template?: string | undefined;
    etl_url?: string | undefined;
    parent_id?: string | undefined;
    groups?: Groups6[] | undefined;
}

export class WorkspaceBulkDeleteRequest implements IWorkspaceBulkDeleteRequest {
    ids!: string[];

    constructor(data?: IWorkspaceBulkDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkspaceBulkDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceBulkDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IWorkspaceBulkDeleteRequest {
    ids: string[];
}

export class WorkspaceBulkAssignApplicationsRequest implements IWorkspaceBulkAssignApplicationsRequest {
    applications!: string[];
    workspaces!: string[];

    constructor(data?: IWorkspaceBulkAssignApplicationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applications = [];
            this.workspaces = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(item);
            }
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkspaceBulkAssignApplicationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceBulkAssignApplicationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item);
        }
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item);
        }
        return data; 
    }
}

export interface IWorkspaceBulkAssignApplicationsRequest {
    applications: string[];
    workspaces: string[];
}

export class WorkspaceBulkAssignGroupsRequest implements IWorkspaceBulkAssignGroupsRequest {
    groups!: string[];
    workspaces!: string[];

    constructor(data?: IWorkspaceBulkAssignGroupsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.groups = [];
            this.workspaces = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkspaceBulkAssignGroupsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceBulkAssignGroupsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item);
        }
        return data; 
    }
}

export interface IWorkspaceBulkAssignGroupsRequest {
    groups: string[];
    workspaces: string[];
}

export class UserProfile implements IUserProfile {
    alias!: string;
    sso!: boolean;
    profile!: User;
    organizationName!: string;

    constructor(data?: IUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.profile = new User();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alias = _data["alias"];
            this.sso = _data["sso"];
            this.profile = _data["profile"] ? User.fromJS(_data["profile"]) : new User();
            this.organizationName = _data["organizationName"];
        }
    }

    static fromJS(data: any): UserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alias"] = this.alias;
        data["sso"] = this.sso;
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["organizationName"] = this.organizationName;
        return data; 
    }
}

export interface IUserProfile {
    alias: string;
    sso: boolean;
    profile: User;
    organizationName: string;
}

export class LoggedInResponse implements ILoggedInResponse {
    value!: boolean;
    sso!: boolean;
    token!: string;
    url!: string;
    ssoHost?: string | undefined;

    constructor(data?: ILoggedInResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.sso = _data["sso"];
            this.token = _data["token"];
            this.url = _data["url"];
            this.ssoHost = _data["ssoHost"];
        }
    }

    static fromJS(data: any): LoggedInResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoggedInResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["sso"] = this.sso;
        data["token"] = this.token;
        data["url"] = this.url;
        data["ssoHost"] = this.ssoHost;
        return data; 
    }
}

export interface ILoggedInResponse {
    value: boolean;
    sso: boolean;
    token: string;
    url: string;
    ssoHost?: string | undefined;
}

export class CheckSelfInfo implements ICheckSelfInfo {
    admin!: boolean;
    applications!: Application[];
    session!: string;

    constructor(data?: ICheckSelfInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applications = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.admin = _data["admin"];
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(Application.fromJS(item));
            }
            this.session = _data["session"];
        }
    }

    static fromJS(data: any): CheckSelfInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CheckSelfInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["admin"] = this.admin;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        data["session"] = this.session;
        return data; 
    }
}

export interface ICheckSelfInfo {
    admin: boolean;
    applications: Application[];
    session: string;
}

export class About implements IAbout {
    serverVersion!: string;
    nodeVersion!: string;
    postgresVersion!: string;
    buildDate!: string;

    constructor(data?: IAbout) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverVersion = _data["serverVersion"];
            this.nodeVersion = _data["nodeVersion"];
            this.postgresVersion = _data["postgresVersion"];
            this.buildDate = _data["buildDate"];
        }
    }

    static fromJS(data: any): About {
        data = typeof data === 'object' ? data : {};
        let result = new About();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverVersion"] = this.serverVersion;
        data["nodeVersion"] = this.nodeVersion;
        data["postgresVersion"] = this.postgresVersion;
        data["buildDate"] = this.buildDate;
        return data; 
    }
}

export interface IAbout {
    serverVersion: string;
    nodeVersion: string;
    postgresVersion: string;
    buildDate: string;
}

export class ApplicationTokenResponse implements IApplicationTokenResponse {
    token!: string;
    refreshToken!: string;
    anagoUrl!: string;
    /** Url a Cheops application is opened at. Equals anagoUrl for legacy applications. */
    platformUrl!: string;
    aasUrl!: string;
    cheops!: boolean;
    canSelectApp!: boolean;
    constructor(data?: IApplicationTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.anagoUrl = _data["anagoUrl"];
            this.platformUrl = _data["platformUrl"];
            this.aasUrl = _data["aasUrl"];
            this.cheops = _data["cheops"];
            this.canSelectApp = _data["canSelectApp"];
        }
    }

    static fromJS(data: any): ApplicationTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["anagoUrl"] = this.anagoUrl;
        data["platformUrl"] = this.platformUrl;
        data["aasUrl"] = this.aasUrl;
        data["cheops"] = this.cheops;
        data["canSelectApp"] = this.canSelectApp;
        return data; 
    }
}

export interface IApplicationTokenResponse {
    token: string;
    refreshToken: string;
    anagoUrl: string;
    /** Url a Cheops application is opened at. Equals anagoUrl for legacy applications. */
    platformUrl: string;
    aasUrl: string;
    cheops: boolean;
    canSelectApp: boolean;
}

export class ApplicationMigrationRequest implements IApplicationMigrationRequest {
    location_path!: string;
    serverHostname!: string;
    newServerHostname!: string;

    constructor(data?: IApplicationMigrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location_path = _data["location_path"];
            this.serverHostname = _data["serverHostname"];
            this.newServerHostname = _data["newServerHostname"];
        }
    }

    static fromJS(data: any): ApplicationMigrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationMigrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location_path"] = this.location_path;
        data["serverHostname"] = this.serverHostname;
        data["newServerHostname"] = this.newServerHostname;
        return data; 
    }
}

export interface IApplicationMigrationRequest {
    location_path: string;
    serverHostname: string;
    newServerHostname: string;
}

export class ZendeskTokenResponse implements IZendeskTokenResponse {
    token!: string;
    url!: string;

    constructor(data?: IZendeskTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): ZendeskTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ZendeskTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["url"] = this.url;
        return data; 
    }
}

export interface IZendeskTokenResponse {
    token: string;
    url: string;
}

export enum InputErrorCode {
    INVALID_EMAIL = "INVALID_EMAIL",
    PASSWORD_NOT_EQUAL = "PASSWORD_NOT_EQUAL",
    INVALID_PASSWORD = "INVALID_PASSWORD",
    EMAIL_NOT_EQUAL = "EMAIL_NOT_EQUAL",
    EMAIL_NOT_AVAILABLE = "EMAIL_NOT_AVAILABLE",
    ALREADY_EXISTS = "ALREADY_EXISTS",
    FIELD_REQUIRED = "FIELD_REQUIRED",
    NOT_A_FAVICON = "NOT_A_FAVICON",
}

export class InputFieldError implements IInputFieldError {
    msg!: Msg;
    location!: string;
    param!: string;
    value!: any;

    constructor(data?: IInputFieldError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.msg = new Msg();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.msg = _data["msg"] ? Msg.fromJS(_data["msg"]) : new Msg();
            this.location = _data["location"];
            this.param = _data["param"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): InputFieldError {
        data = typeof data === 'object' ? data : {};
        let result = new InputFieldError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msg"] = this.msg ? this.msg.toJSON() : <any>undefined;
        data["location"] = this.location;
        data["param"] = this.param;
        data["value"] = this.value;
        return data; 
    }
}

export interface IInputFieldError {
    msg: Msg;
    location: string;
    param: string;
    value: any;
}

export class InputError implements IInputError {
    stack?: string | undefined;
    statusCode!: number;
    errorCode!: ErrorCode;
    fields!: InputFieldError[];

    constructor(data?: IInputError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fields = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stack = _data["stack"];
            this.statusCode = _data["statusCode"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(InputFieldError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InputError {
        data = typeof data === 'object' ? data : {};
        let result = new InputError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stack"] = this.stack;
        data["statusCode"] = this.statusCode;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IInputError {
    stack?: string | undefined;
    statusCode: number;
    errorCode: ErrorCode;
    fields: InputFieldError[];
}

export class WrappedErrorInputError implements IWrappedErrorInputError {
    error!: InputError;

    constructor(data?: IWrappedErrorInputError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.error = new InputError();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] ? InputError.fromJS(_data["error"]) : new InputError();
        }
    }

    static fromJS(data: any): WrappedErrorInputError {
        data = typeof data === 'object' ? data : {};
        let result = new WrappedErrorInputError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IWrappedErrorInputError {
    error: InputError;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    email!: string;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data; 
    }
}

export interface IForgotPasswordRequest {
    email: string;
}

export class PasswordResetRequest implements IPasswordResetRequest {
    newPassword!: string;
    confirmPassword!: string;

    constructor(data?: IPasswordResetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): PasswordResetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        return data; 
    }
}

export interface IPasswordResetRequest {
    newPassword: string;
    confirmPassword: string;
}

export class UpdateAccountRequest implements IUpdateAccountRequest {
    email!: string;
    confirm_email!: string;
    first_name!: string;
    last_name!: string;

    constructor(data?: IUpdateAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.confirm_email = _data["confirm_email"];
            this.first_name = _data["first_name"];
            this.last_name = _data["last_name"];
        }
    }

    static fromJS(data: any): UpdateAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["confirm_email"] = this.confirm_email;
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        return data; 
    }
}

export interface IUpdateAccountRequest {
    email: string;
    confirm_email: string;
    first_name: string;
    last_name: string;
}

export class AASTheme implements IAASTheme {
    logoImage!: string;
    backgroundImage!: string;
    iconImage!: string;
    accentColor!: string;
    organizationName!: string;
    activeDirectory!: boolean;
    hideGroups!: boolean;
    favicon!: string;

    constructor(data?: IAASTheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoImage = _data["logoImage"];
            this.backgroundImage = _data["backgroundImage"];
            this.iconImage = _data["iconImage"];
            this.accentColor = _data["accentColor"];
            this.organizationName = _data["organizationName"];
            this.activeDirectory = _data["activeDirectory"];
            this.hideGroups = _data["hideGroups"];
            this.favicon = _data["favicon"];
        }
    }

    static fromJS(data: any): AASTheme {
        data = typeof data === 'object' ? data : {};
        let result = new AASTheme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoImage"] = this.logoImage;
        data["backgroundImage"] = this.backgroundImage;
        data["iconImage"] = this.iconImage;
        data["accentColor"] = this.accentColor;
        data["organizationName"] = this.organizationName;
        data["activeDirectory"] = this.activeDirectory;
        data["hideGroups"] = this.hideGroups;
        data["favicon"] = this.favicon;
        return data; 
    }
}

export interface IAASTheme {
    logoImage: string;
    backgroundImage: string;
    iconImage: string;
    accentColor: string;
    organizationName: string;
    activeDirectory: boolean;
    hideGroups: boolean;
    favicon: string;
}

export class Server implements IServer {
    id!: string;
    anagoVersion?: string | undefined;
    hostname!: string;
    secure!: boolean;
    atp_url!: string;
    key!: string;
    maintenanceMode?: boolean | undefined;
    bbm_port?: string | undefined;
    applications?: Applications5[] | undefined;

    constructor(data?: IServer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.anagoVersion = _data["anagoVersion"];
            this.hostname = _data["hostname"];
            this.secure = _data["secure"];
            this.atp_url = _data["atp_url"];
            this.key = _data["key"];
            this.maintenanceMode = _data["maintenanceMode"];
            this.bbm_port = _data["bbm_port"];
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(Applications5.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Server {
        data = typeof data === 'object' ? data : {};
        let result = new Server();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["anagoVersion"] = this.anagoVersion;
        data["hostname"] = this.hostname;
        data["secure"] = this.secure;
        data["atp_url"] = this.atp_url;
        data["key"] = this.key;
        data["maintenanceMode"] = this.maintenanceMode;
        data["bbm_port"] = this.bbm_port;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IServer {
    id: string;
    anagoVersion?: string | undefined;
    hostname: string;
    secure: boolean;
    atp_url: string;
    key: string;
    maintenanceMode?: boolean | undefined;
    bbm_port?: string | undefined;
    applications?: Applications5[] | undefined;
}

export class ServerCollection implements IServerCollection {
    items!: Server[];
    count?: number | undefined;
    ordering?: Ordering[] | undefined;
    start?: number | undefined;
    limit?: number | undefined;
    filter?: Filter5 | undefined;

    constructor(data?: IServerCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Server.fromJS(item));
            }
            this.count = _data["count"];
            if (Array.isArray(_data["ordering"])) {
                this.ordering = [] as any;
                for (let item of _data["ordering"])
                    this.ordering!.push(Ordering.fromJS(item));
            }
            this.start = _data["start"];
            this.limit = _data["limit"];
            this.filter = _data["filter"] ? Filter5.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServerCollection {
        data = typeof data === 'object' ? data : {};
        let result = new ServerCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["count"] = this.count;
        if (Array.isArray(this.ordering)) {
            data["ordering"] = [];
            for (let item of this.ordering)
                data["ordering"].push(item.toJSON());
        }
        data["start"] = this.start;
        data["limit"] = this.limit;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IServerCollection {
    items: Server[];
    count?: number | undefined;
    ordering?: Ordering[] | undefined;
    start?: number | undefined;
    limit?: number | undefined;
    filter?: Filter5 | undefined;
}

export class ServerCreationRequest implements IServerCreationRequest {
    hostname!: string;
    secure!: boolean;
    atp_url!: string;

    constructor(data?: IServerCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hostname = _data["hostname"];
            this.secure = _data["secure"];
            this.atp_url = _data["atp_url"];
        }
    }

    static fromJS(data: any): ServerCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServerCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hostname"] = this.hostname;
        data["secure"] = this.secure;
        data["atp_url"] = this.atp_url;
        return data; 
    }
}

export interface IServerCreationRequest {
    hostname: string;
    secure: boolean;
    atp_url: string;
}

export class ServerUpdateRequest implements IServerUpdateRequest {
    secure?: boolean | undefined;
    atp_url!: string;

    constructor(data?: IServerUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secure = _data["secure"];
            this.atp_url = _data["atp_url"];
        }
    }

    static fromJS(data: any): ServerUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServerUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secure"] = this.secure;
        data["atp_url"] = this.atp_url;
        return data; 
    }
}

export interface IServerUpdateRequest {
    secure?: boolean | undefined;
    atp_url: string;
}

export class ServerNewKeyRequest implements IServerNewKeyRequest {
    ids!: string[];

    constructor(data?: IServerNewKeyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ServerNewKeyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServerNewKeyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IServerNewKeyRequest {
    ids: string[];
}

export class ServerBulkDeleteRequest implements IServerBulkDeleteRequest {
    ids!: string[];

    constructor(data?: IServerBulkDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ServerBulkDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServerBulkDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IServerBulkDeleteRequest {
    ids: string[];
}

export class ServerMaintenanceModeRequest implements IServerMaintenanceModeRequest {
    value!: boolean;

    constructor(data?: IServerMaintenanceModeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ServerMaintenanceModeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServerMaintenanceModeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data; 
    }
}

export interface IServerMaintenanceModeRequest {
    value: boolean;
}

export class Anonymous implements IAnonymous {
    id!: string;
    title!: string;

    constructor(data?: IAnonymous) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): Anonymous {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data; 
    }
}

export interface IAnonymous {
    id: string;
    title: string;
}

export class Anonymous2 implements IAnonymous2 {
    key!: string;
    hostname!: string;
    secure!: boolean;

    constructor(data?: IAnonymous2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.hostname = _data["hostname"];
            this.secure = _data["secure"];
        }
    }

    static fromJS(data: any): Anonymous2 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["hostname"] = this.hostname;
        data["secure"] = this.secure;
        return data; 
    }
}

export interface IAnonymous2 {
    key: string;
    hostname: string;
    secure: boolean;
}

export class Anonymous3 implements IAnonymous3 {
    csrfToken!: string;

    constructor(data?: IAnonymous3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.csrfToken = _data["csrfToken"];
        }
    }

    static fromJS(data: any): Anonymous3 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["csrfToken"] = this.csrfToken;
        return data; 
    }
}

export interface IAnonymous3 {
    csrfToken: string;
}

export class Applications implements IApplications {
    id!: string;

    constructor(data?: IApplications) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Applications {
        data = typeof data === 'object' ? data : {};
        let result = new Applications();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IApplications {
    id: string;
}

export class Groups implements IGroups {
    id!: string;
    workspaces?: Workspaces4[] | undefined;

    constructor(data?: IGroups) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(Workspaces4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Groups {
        data = typeof data === 'object' ? data : {};
        let result = new Groups();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGroups {
    id: string;
    workspaces?: Workspaces4[] | undefined;
}

export class Workspace2 implements IWorkspace2 {
    id!: string;

    constructor(data?: IWorkspace2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Workspace2 {
        data = typeof data === 'object' ? data : {};
        let result = new Workspace2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IWorkspace2 {
    id: string;
}

export class Privileges implements IPrivileges {
    name!: string;

    constructor(data?: IPrivileges) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Privileges {
        data = typeof data === 'object' ? data : {};
        let result = new Privileges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IPrivileges {
    name: string;
}

export enum OrderingOrder {
    Asc = "asc",
    Desc = "desc",
}

export class Filter implements IFilter {
    w?: string[] | undefined;
    a?: string[] | undefined;
    g?: string[] | undefined;
    search?: string | undefined;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["w"])) {
                this.w = [] as any;
                for (let item of _data["w"])
                    this.w!.push(item);
            }
            if (Array.isArray(_data["a"])) {
                this.a = [] as any;
                for (let item of _data["a"])
                    this.a!.push(item);
            }
            if (Array.isArray(_data["g"])) {
                this.g = [] as any;
                for (let item of _data["g"])
                    this.g!.push(item);
            }
            this.search = _data["search"];
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.w)) {
            data["w"] = [];
            for (let item of this.w)
                data["w"].push(item);
        }
        if (Array.isArray(this.a)) {
            data["a"] = [];
            for (let item of this.a)
                data["a"].push(item);
        }
        if (Array.isArray(this.g)) {
            data["g"] = [];
            for (let item of this.g)
                data["g"].push(item);
        }
        data["search"] = this.search;
        return data; 
    }
}

export interface IFilter {
    w?: string[] | undefined;
    a?: string[] | undefined;
    g?: string[] | undefined;
    search?: string | undefined;
}

export class Applications2 implements IApplications2 {
    id!: string;
    value!: boolean;

    constructor(data?: IApplications2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Applications2 {
        data = typeof data === 'object' ? data : {};
        let result = new Applications2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data; 
    }
}

export interface IApplications2 {
    id: string;
    value: boolean;
}

export class Groups2 implements IGroups2 {
    id!: string;
    value!: boolean;

    constructor(data?: IGroups2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Groups2 {
        data = typeof data === 'object' ? data : {};
        let result = new Groups2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data; 
    }
}

export interface IGroups2 {
    id: string;
    value: boolean;
}

export class Privileges2 implements IPrivileges2 {
    name!: string;
    value!: boolean;

    constructor(data?: IPrivileges2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Privileges2 {
        data = typeof data === 'object' ? data : {};
        let result = new Privileges2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IPrivileges2 {
    name: string;
    value: boolean;
}

export class Applications3 implements IApplications3 {
    id!: string;
    value!: boolean;

    constructor(data?: IApplications3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Applications3 {
        data = typeof data === 'object' ? data : {};
        let result = new Applications3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data; 
    }
}

export interface IApplications3 {
    id: string;
    value: boolean;
}

export class Groups3 implements IGroups3 {
    id!: string;
    value!: boolean;

    constructor(data?: IGroups3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Groups3 {
        data = typeof data === 'object' ? data : {};
        let result = new Groups3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data; 
    }
}

export interface IGroups3 {
    id: string;
    value: boolean;
}

export class Privileges3 implements IPrivileges3 {
    name!: string;
    value!: boolean;

    constructor(data?: IPrivileges3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Privileges3 {
        data = typeof data === 'object' ? data : {};
        let result = new Privileges3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IPrivileges3 {
    name: string;
    value: boolean;
}

export class Options implements IOptions {
    emailUsers!: boolean;
    workspaceId!: string;

    constructor(data?: IOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailUsers = _data["emailUsers"];
            this.workspaceId = _data["workspaceId"];
        }
    }

    static fromJS(data: any): Options {
        data = typeof data === 'object' ? data : {};
        let result = new Options();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailUsers"] = this.emailUsers;
        data["workspaceId"] = this.workspaceId;
        return data; 
    }
}

export interface IOptions {
    emailUsers: boolean;
    workspaceId: string;
}

export class Server2 implements IServer2 {
    hostname!: string;
    secure!: boolean;
    atp_url!: string;

    constructor(data?: IServer2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hostname = _data["hostname"];
            this.secure = _data["secure"];
            this.atp_url = _data["atp_url"];
        }
    }

    static fromJS(data: any): Server2 {
        data = typeof data === 'object' ? data : {};
        let result = new Server2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hostname"] = this.hostname;
        data["secure"] = this.secure;
        data["atp_url"] = this.atp_url;
        return data; 
    }
}

export interface IServer2 {
    hostname: string;
    secure: boolean;
    atp_url: string;
}

export class Users implements IUsers {
    id!: string;

    constructor(data?: IUsers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Users {
        data = typeof data === 'object' ? data : {};
        let result = new Users();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IUsers {
    id: string;
}

export class Workspace3 implements IWorkspace3 {
    id!: string;

    constructor(data?: IWorkspace3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Workspace3 {
        data = typeof data === 'object' ? data : {};
        let result = new Workspace3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IWorkspace3 {
    id: string;
}

export class Filter2 implements IFilter2 {
    u?: string[] | undefined;
    w?: string[] | undefined;
    search?: string | undefined;

    constructor(data?: IFilter2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["u"])) {
                this.u = [] as any;
                for (let item of _data["u"])
                    this.u!.push(item);
            }
            if (Array.isArray(_data["w"])) {
                this.w = [] as any;
                for (let item of _data["w"])
                    this.w!.push(item);
            }
            this.search = _data["search"];
        }
    }

    static fromJS(data: any): Filter2 {
        data = typeof data === 'object' ? data : {};
        let result = new Filter2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.u)) {
            data["u"] = [];
            for (let item of this.u)
                data["u"].push(item);
        }
        if (Array.isArray(this.w)) {
            data["w"] = [];
            for (let item of this.w)
                data["w"].push(item);
        }
        data["search"] = this.search;
        return data; 
    }
}

export interface IFilter2 {
    u?: string[] | undefined;
    w?: string[] | undefined;
    search?: string | undefined;
}

export class Users2 implements IUsers2 {
    id!: string;

    constructor(data?: IUsers2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Users2 {
        data = typeof data === 'object' ? data : {};
        let result = new Users2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IUsers2 {
    id: string;
}

export class Workspaces implements IWorkspaces {
    id!: string;

    constructor(data?: IWorkspaces) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Workspaces {
        data = typeof data === 'object' ? data : {};
        let result = new Workspaces();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IWorkspaces {
    id: string;
}

export class Filter3 implements IFilter3 {
    u?: string[] | undefined;
    w?: string[] | undefined;
    search?: string | undefined;

    constructor(data?: IFilter3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["u"])) {
                this.u = [] as any;
                for (let item of _data["u"])
                    this.u!.push(item);
            }
            if (Array.isArray(_data["w"])) {
                this.w = [] as any;
                for (let item of _data["w"])
                    this.w!.push(item);
            }
            this.search = _data["search"];
        }
    }

    static fromJS(data: any): Filter3 {
        data = typeof data === 'object' ? data : {};
        let result = new Filter3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.u)) {
            data["u"] = [];
            for (let item of this.u)
                data["u"].push(item);
        }
        if (Array.isArray(this.w)) {
            data["w"] = [];
            for (let item of this.w)
                data["w"].push(item);
        }
        data["search"] = this.search;
        return data; 
    }
}

export interface IFilter3 {
    u?: string[] | undefined;
    w?: string[] | undefined;
    search?: string | undefined;
}

export class Workspaces2 implements IWorkspaces2 {
    value!: boolean;
    id!: string;

    constructor(data?: IWorkspaces2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Workspaces2 {
        data = typeof data === 'object' ? data : {};
        let result = new Workspaces2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["id"] = this.id;
        return data; 
    }
}

export interface IWorkspaces2 {
    value: boolean;
    id: string;
}

export class Workspaces3 implements IWorkspaces3 {
    id!: string;
    value!: boolean;

    constructor(data?: IWorkspaces3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Workspaces3 {
        data = typeof data === 'object' ? data : {};
        let result = new Workspaces3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data; 
    }
}

export interface IWorkspaces3 {
    id: string;
    value: boolean;
}

export class Parent implements IParent {
    id!: string;

    constructor(data?: IParent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Parent {
        data = typeof data === 'object' ? data : {};
        let result = new Parent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IParent {
    id: string;
}

export class Applications4 implements IApplications4 {
    id!: string;

    constructor(data?: IApplications4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Applications4 {
        data = typeof data === 'object' ? data : {};
        let result = new Applications4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IApplications4 {
    id: string;
}

export class Groups4 implements IGroups4 {
    id!: string;

    constructor(data?: IGroups4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Groups4 {
        data = typeof data === 'object' ? data : {};
        let result = new Groups4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IGroups4 {
    id: string;
}

export class Users3 implements IUsers3 {
    id!: string;

    constructor(data?: IUsers3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Users3 {
        data = typeof data === 'object' ? data : {};
        let result = new Users3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IUsers3 {
    id: string;
}

export class Filter4 implements IFilter4 {
    u?: string[] | undefined;
    a?: string[] | undefined;
    g?: string[] | undefined;
    search?: string | undefined;

    constructor(data?: IFilter4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["u"])) {
                this.u = [] as any;
                for (let item of _data["u"])
                    this.u!.push(item);
            }
            if (Array.isArray(_data["a"])) {
                this.a = [] as any;
                for (let item of _data["a"])
                    this.a!.push(item);
            }
            if (Array.isArray(_data["g"])) {
                this.g = [] as any;
                for (let item of _data["g"])
                    this.g!.push(item);
            }
            this.search = _data["search"];
        }
    }

    static fromJS(data: any): Filter4 {
        data = typeof data === 'object' ? data : {};
        let result = new Filter4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.u)) {
            data["u"] = [];
            for (let item of this.u)
                data["u"].push(item);
        }
        if (Array.isArray(this.a)) {
            data["a"] = [];
            for (let item of this.a)
                data["a"].push(item);
        }
        if (Array.isArray(this.g)) {
            data["g"] = [];
            for (let item of this.g)
                data["g"].push(item);
        }
        data["search"] = this.search;
        return data; 
    }
}

export interface IFilter4 {
    u?: string[] | undefined;
    a?: string[] | undefined;
    g?: string[] | undefined;
    search?: string | undefined;
}

export class Groups5 implements IGroups5 {
    id!: string;
    value!: boolean;

    constructor(data?: IGroups5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Groups5 {
        data = typeof data === 'object' ? data : {};
        let result = new Groups5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data; 
    }
}

export interface IGroups5 {
    id: string;
    value: boolean;
}

export class Groups6 implements IGroups6 {
    id!: string;
    value!: boolean;

    constructor(data?: IGroups6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Groups6 {
        data = typeof data === 'object' ? data : {};
        let result = new Groups6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data; 
    }
}

export interface IGroups6 {
    id: string;
    value: boolean;
}

export class Msg implements IMsg {
    errorCode!: InputErrorCode;
    hideField?: boolean | undefined;

    constructor(data?: IMsg) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            this.hideField = _data["hideField"];
        }
    }

    static fromJS(data: any): Msg {
        data = typeof data === 'object' ? data : {};
        let result = new Msg();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["hideField"] = this.hideField;
        return data; 
    }
}

export interface IMsg {
    errorCode: InputErrorCode;
    hideField?: boolean | undefined;
}

export class Applications5 implements IApplications5 {
    id!: string;

    constructor(data?: IApplications5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Applications5 {
        data = typeof data === 'object' ? data : {};
        let result = new Applications5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IApplications5 {
    id: string;
}

export class Filter5 implements IFilter5 {
    u?: string[] | undefined;
    a?: string[] | undefined;
    g?: string[] | undefined;
    search?: string | undefined;

    constructor(data?: IFilter5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["u"])) {
                this.u = [] as any;
                for (let item of _data["u"])
                    this.u!.push(item);
            }
            if (Array.isArray(_data["a"])) {
                this.a = [] as any;
                for (let item of _data["a"])
                    this.a!.push(item);
            }
            if (Array.isArray(_data["g"])) {
                this.g = [] as any;
                for (let item of _data["g"])
                    this.g!.push(item);
            }
            this.search = _data["search"];
        }
    }

    static fromJS(data: any): Filter5 {
        data = typeof data === 'object' ? data : {};
        let result = new Filter5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.u)) {
            data["u"] = [];
            for (let item of this.u)
                data["u"].push(item);
        }
        if (Array.isArray(this.a)) {
            data["a"] = [];
            for (let item of this.a)
                data["a"].push(item);
        }
        if (Array.isArray(this.g)) {
            data["g"] = [];
            for (let item of this.g)
                data["g"].push(item);
        }
        data["search"] = this.search;
        return data; 
    }
}

export interface IFilter5 {
    u?: string[] | undefined;
    a?: string[] | undefined;
    g?: string[] | undefined;
    search?: string | undefined;
}

export class Workspaces4 implements IWorkspaces4 {
    id!: string;

    constructor(data?: IWorkspaces4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Workspaces4 {
        data = typeof data === 'object' ? data : {};
        let result = new Workspaces4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IWorkspaces4 {
    id: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}